/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class NotFoundController {
    /** @ngInject */
    constructor($window, $log) {
        this.$window = $window;
        this.$log = $log;
        this.$log.debug('Controller \'NotFound\' loaded');
    }

    goToLastValidState() {
        // If we reached the not found page, it is because the previous state was not found. That's why we must go
        // 2 states back to reach a valid state.
        this.$window.history.go(-2);
    }
}

export const NotFoundComponent = {
    template: require('./not-found.html'),
    controller: NotFoundController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/NotFound.js